/**
 * Defines the columns
 * And any action against the columns
 */
export class OrderInboxColumnsModel {
	private _columns: Array<any>;
	constructor() {
		this._columns = [
			{
				headerName: 'Flags',
				width: 70,
				cellRenderer: 'customFlagsCellComponent',
				resizable: false
			},
			{
				headerName: 'Reference ID',
				field: 'externalId',
				width: 80,
				cellRenderer: 'customIDCellComponent'
			},
			{
				headerName: 'Address',
				field: 'description',
				width: 220
			},
			{
				headerName: 'Client',
				field: 'clientName',
				width: 150
			},
			{
				headerName: 'Form type',
				field: 'formType',
				width: 80
			},{
				headerName: 'Due Date',
				field: 'dueDate',
				width: 100,
				cellRenderer: 'customDateCellComponent'
			},
			{
				headerName: 'Ready for QC',
				field: 'created',
				width: 100,
				cellRenderer: 'customDateCellComponent'
			},
			{
				headerName: 'Status',
				field: 'status',
				width: 100,
				cellRenderer: 'customStatusCellComponent'
			},
			{
				headerName: 'Smart QC',
				field: 'smartQCStateDescription',
				width: 160,
				cellRenderer: 'customSmartqcCellComponent'
			},
			{
				headerName: 'Origin',
				field: 'externalTrackingProvider',
				width: 100
			},
			{
				headerName: 'Revised',
				field: 'revised',
				width: 70
			},
			{
				headerName: 'Actions',
				width: 130,
				resizable: true,
				cellRenderer: 'customActionCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
